export const isDevtoolsAllowed = () => {
    const { LOCAL_ENVIRONMENT, DEV_ENVIRONMENT, STG_ENVIRONMENT, QA_ENVIRONMENT } = require('constants/index');

    const allowedEnvironments = [LOCAL_ENVIRONMENT, DEV_ENVIRONMENT, STG_ENVIRONMENT, QA_ENVIRONMENT];
    return allowedEnvironments.includes(__ENV__);
};
